import React from 'react'
import "./Header.css";

const Header = () => {
    return (
        <div className="Header"> 
            <h1 className="Title">Psa-Tasks</h1>
        </div>
    )
}

export default Header
